var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3017 16.2533C16.5102 14.5852 17.9282 13.3334 19.6094 13.3334H60.3907C62.0719 13.3334 63.4899 14.5852 63.6984 16.2533L69.5317 62.9199C69.7804 64.9094 68.229 66.6667 66.224 66.6667H13.776C11.771 66.6667 10.2197 64.9094 10.4684 62.9199L16.3017 16.2533Z",
    fill: "#63FF6F",
    stroke: "#09D818",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30C25 30 28.3333 36.6667 40 36.6667C51.6667 36.6667 55 30 55 30",
    stroke: "#09D818",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEb);
export default __webpack_public_path__ + "static/media/eb.fa1c2ac803eff181f07b3dbf9d5d68cb.svg";
export { ForwardRef as ReactComponent };